import * as React from "react";

import "./user-management-modal.scss";

import {isApiTrue}                  from "@Common/logic/is-api-true";
import {cs}                         from "@Common/react/chain-services";
import {consumeContext}             from "@Common/react/context";
import {Load2}                      from "@Common/react/load2";
import {UseState}                   from "@Common/react/use-state";
import {ConfirmDialog}              from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {ModalService3}              from "@Common/ui-components/modal-service-3/modal-service-3";
import {needsConfirmation}          from "@Common/ui-components/needs-confirmation/needs-confirmation";
import {parseUrlQuery}              from "@Common/utils/parse-url-query";
import {COMPANY_LEVEL}              from "@Xpresso/routes/common/logic/user-level";

import {CustomizationMenu}          from "./menus/customization-menu/customization-menu";
import {PermissionsMenu}            from "./menus/permissions-menu/permissions-menu";
import {SecurityMenu}               from "./menus/security-menu/security-menu";
import {UserInformationMenu}        from "./menus/user-information-menu/user-information-menu";
import {UserManagementModalLayout}  from "./user-management-modal-layout";

export const UserManagementModal = ({initShow, branchId, reload, next: rootNext, baseUrl}) => cs(
    consumeContext("routerHistory"),
    ["dataUpdated", (_, next) => UseState({next})],
    ["confirmCloseDialog", ({}, next) => ConfirmDialog({next})],
    ({dataUpdated, confirmCloseDialog, routerHistory}, next) => <>
        {initShow ? (
            <ModalService3 {...{
                initShow: true,
                width: 536,
                hideCloseButton: true,
                xdQaName: "User Management Modal",
                onPassiveClose: async () => {
                    if(dataUpdated.value) {
                        const proceed = await needsConfirmation({
                            confirmDialog: confirmCloseDialog
                        })
                        if(proceed) {
                            reload()
                            dataUpdated.onChange(false);
                            routerHistory.replace(baseUrl)
                            return true
                        }
                        return false;
                    }
                    else {
                        reload()
                        routerHistory.replace(baseUrl)
                    }
                },
                rootNext,
                next,
            }}/>
        ) : (
            rootNext()
        )}
    </>,
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("userLevels"),
    ["query", ({}, next) => next(parseUrlQuery(window.location.search))],
    ["branchId", ({query}, next) => next(branchId || query?.branch)],
    ["agent", ({apis, query}, next) => Load2({
        fetch: () => apis.next.session.getAgent({agentId: query['agent']}),
        next,
    })],
    ["user", ({apis, agent}, next) => agent.value ? (
        Load2({
            fetch: () => apis.next.userProfile.getUserProfile(agent.value.idUser),
            next,
        })
    ) : (
        next({loading: true})
    )],
    ["readOnly", ({agent, user, userLevels, company}, next) => next(
        {
            inactive: !agent?.value?.agentActive,
            canEdit: userLevels.userLevel === COMPANY_LEVEL ? true : isApiTrue(company?.profile.branchEditAgentDisplay),
            companyAdmin: userLevels.userLevel > user?.value?.loginLevel
        }
    )],
    ({agent, branchId, user, query, readOnly, dataUpdated, confirmCloseDialog, routerHistory}, next) => (
        agent.loading || user.loading ? (
            <div className="user-management-modal-c8f">
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            </div>
        ) : agent.value?.errorInfo || user.value?.errorInfo ? (
            routerHistory.replace(baseUrl)
        ) : (
            <div className="user-management-modal-c8f">
                {UserManagementModalLayout({agent, branchId, user, active: query['menu'], readOnly, dataUpdated, confirmCloseDialog, baseUrl, reload})}
                {next()}
            </div>
        )
    ),
    ({agent, user, query, readOnly, dataUpdated, routerHistory}) => (
        query['menu'] === 'general' ? (
            UserInformationMenu({agent, readOnly, dataUpdated})
        ) : query['menu'] === 'customization' ? (
            CustomizationMenu({agent, readOnly, dataUpdated})
        ) : query['menu'] === 'security' ? (
            SecurityMenu({user, readOnly, dataUpdated})
        ) : query['menu'] === 'permissions' ? (
            PermissionsMenu({user, readOnly, dataUpdated})
        ) : (
            routerHistory.replace(baseUrl)
        )
    )
);
